export default __webpack_public_path__ + "static/media/5.ba276729.png";